import { AssignmentInd, Close } from "@mui/icons-material"
import { Autocomplete, Button, Chip, CircularProgress, FormControl, Grid2, IconButton, InputLabel, MenuItem, Select, SelectChangeEvent, TextField, Typography } from "@mui/material"
import { Dispatch, memo, SetStateAction, useCallback, useEffect, useMemo, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { IBranch, IEmployee, IUser } from "sierra"
import api from "../../../utils/axios"
import socket from "../../../utils/socket"
import { enqueueSnackbar } from "notistack"
import { useApp } from "../../../contexts/AppContext"

const AssignEmployees = memo(({ setOpenAssignEmployees }: { setOpenAssignEmployees: Dispatch<SetStateAction<boolean>> }) => {

    const { lang } = useApp()
    const location = useLocation()
    const navigate = useNavigate()
    const {translate} = useApp()

    const branch: IBranch = useMemo(() => location.state?.branch, [location])

    const [employees, setEmployees] = useState<IEmployee[]>()
    const [selectedEmployees, setSelectedEmployees] = useState<number[]>([])
    const [updated, setUpdated] = useState(false)
    const [apiCall, setApiCall] = useState<boolean>(false)

    // const handleAddToManagers = useCallback((e: SelectChangeEvent) => {
    //     if (!selectedManagers.includes(parseInt(e.target.value as string))) setSelectedManagers(prev => [...prev, parseInt(e.target.value as string)])
    // }
    //     , [selectedManagers])

    // const handleDeleteFromManagers = useCallback((e: number) => setSelectedManagers(prev => prev.filter(p => e !== p))
    //     , [])

    const handleEmployeeChange = (_event: any, newValue: IEmployee[]) => {
        setUpdated(true)
        setSelectedEmployees(newValue.map((e) => e.user_id));
    };

    const handleAssignEmployees = useCallback(() => {
        if (!employees) return
        setApiCall(true)
        const prevEmployees = employees.filter(emp => emp.branch_id === branch.branch_id).map(e => e.user_id)
        Promise.all(
            selectedEmployees.filter(sid => !prevEmployees.includes(sid)).map(uid => api.patch(`/employees/${uid}/branch`, { branch_id: branch.branch_id })).concat(
                prevEmployees.filter(pid => !selectedEmployees.includes(pid)).map(pid => api.patch(`/employees/${pid}/branch`, { branch_id: null }))
            )
        ).then(() => {
            setUpdated(false)
            enqueueSnackbar('Updated Successfully', { variant: 'success' })
        }).catch(console.error).finally(() => {
            setApiCall(false)
            fetchEmployees()
        })
        // api.patch(`/branches/${branch.branch_id}/assignManagers`, { managers: selectedManagers }, { meta: { showSnackbar: true } }).then(() => {
        //     setApiCall(false)
        // }).catch(() => {
        //     console.error
        //     setApiCall(false)
        // })
    }, [branch, selectedEmployees])


    const fetchEmployees = useCallback(() => api.get('/employees').then(res => setEmployees(res.data)).catch(console.error), [])

    useEffect(() => {
        fetchEmployees()
        // socket.on("managers_branches_changed", fetchManagers);
        // return () => {
        //     socket.off("managers_branches_changed", fetchManagers);
        // }
    }, [branch])

    useEffect(() => {
        if (!employees) return
        setSelectedEmployees(employees.filter(emp => emp.branch_id === branch.branch_id).map(e => e.user_id))
    }, [employees])

    // useEffect(() => {
    //     console.log(selectedManagers);
    //     console.log(branch.branch_managers);
    //     console.log(selectedManagers.every((e, i) => e === branch.branch_managers[i]));
    // }, [selectedManagers])

    // useEffect(() => {
    //     setSelectedManagers(branch?.branch_managers || [])
    // }, [location])

    const getOptionLabel = useCallback((option: IEmployee) => {
        return `${option.name} ${option.branch && option.branch.branch_id !== branch.branch_id ? `(${option.branch.branch_name[lang]})` : ''}`.trim()
    }, [branch])

    return (
        <Grid2 container padding={2} spacing={4} flexDirection={'column'}>
            <Grid2 container size={'auto'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>

                <Grid2>
                    <Typography variant='h5'>
                        {translate("Assign Employees")}
                    </Typography>
                </Grid2>

                <Grid2>
                    <IconButton onClick={() => setOpenAssignEmployees(false)}>
                        <Close />
                    </IconButton>
                </Grid2>

            </Grid2>


            {!employees ? <CircularProgress /> : employees.length == 0 ?
                <Grid2 container flexDirection={'column'}>
                    <Grid2>
                        <Typography>{translate("No employees, please invite employees.")}</Typography>
                    </Grid2>
                    <Grid2>
                        <Button fullWidth variant="contained" onClick={() => navigate('/system/users/invite')}>{translate("Invite Employees")}</Button>
                    </Grid2>
                </Grid2>
                :
                <Grid2 container size={'grow'} flexDirection={'column'} spacing={4}>
                    <Grid2>
                        <Autocomplete
                            multiple
                            onChange={handleEmployeeChange}
                            options={employees}
                            getOptionLabel={getOptionLabel}
                            getOptionDisabled={(option) => option.branch ? true : false}
                            value={employees.filter(emp => selectedEmployees.includes(emp.user_id))}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="standard"
                                    label={translate("Select Employees")}
                                />
                            )}
                        />
                    </Grid2>

                    {/* <Grid2>
                        <FormControl fullWidth>
                            <InputLabel shrink={false}>Select a manager.</InputLabel>
                            <Select
                                value={''}
                                label="Select a Manager"
                                onChange={handleAddToManagers}
                                variant="filled"
                            >
                                {managers.map((m, i) => <MenuItem key={i} value={m.user_id}>{m.name}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid2>
                    <Grid2 container display={'flex'} alignItems={'center'} spacing={1} padding={2} sx={{ border: t => `1px solid ${t.palette.primary.main}` }}>
                        <Grid2>
                            <Typography>Assigned Managers: </Typography>
                        </Grid2>
                        {
                            selectedManagers.length == 0 ?
                                <Typography color="error">No managers assigned. Please select a manager.</Typography> :
                                selectedManagers.map((sm, i) => managers.map(m => m.user_id == sm && <Grid2><Chip key={i} label={m.name} onDelete={() => handleDeleteFromManagers(sm)}></Chip></Grid2>))
                        }
                    </Grid2> */}
                    <Grid2>
                        <Button variant="contained" fullWidth onClick={handleAssignEmployees}
                            disabled={apiCall || !updated}
                            endIcon={apiCall ? <CircularProgress /> : <AssignmentInd />}>
                            {translate("Assign Employees")}
                        </Button>
                    </Grid2>
                </Grid2>
            }


        </Grid2>
    )
})

export default AssignEmployees
